"use client";
import {
  DropdownProvider
} from "./chunk-WRRPXIUB.mjs";
import {
  useDropdown
} from "./chunk-COZ4ZNVY.mjs";

// src/dropdown.tsx
import React from "react";
import { Popover } from "@nextui-org/popover";
import { jsx, jsxs } from "react/jsx-runtime";
var Dropdown = (props) => {
  const { children, ...otherProps } = props;
  const context = useDropdown(otherProps);
  const [menuTrigger, menu] = React.Children.toArray(children);
  return /* @__PURE__ */ jsx(DropdownProvider, { value: context, children: /* @__PURE__ */ jsxs(Popover, { ...context.getPopoverProps(), children: [
    menuTrigger,
    menu
  ] }) });
};
Dropdown.displayName = "NextUI.Dropdown";
var dropdown_default = Dropdown;

export {
  dropdown_default
};
